module.exports = __webpack_public_path__ + "img/symbol_11.2276efc8.png";